import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultAffinityGroupsPage from './Pages/DefaultAffinityGroupsPage';
import WizardPage from './Pages/WizardPage';

const AffinityGroupsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:affinityGroupSettingId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultAffinityGroupsPage />
            </Route>
        </Switch>
    );
};

export default AffinityGroupsRouter;
